module.exports = __webpack_public_path__ + "static/media/upi_crop.69076751.png";